<template>
    <div>
        <!-- A2P Campaign (if showA2pCampaign is true) -->
        <template v-if="showA2pCampaign">
            <p v-if="hasA2pCampaign" class="mb-0">
                <span class="font-weight-bold">#{{ a2pCampaignId }} - A2P Campaign</span>
            </p>
            <p v-if="hasA2pCampaign" class="mb-0">
                {{ a2pCampaignSid }}
            </p>
        </template>

        <!-- Friendly Name -->
        <p class="mb-0">
            <span class="font-weight-bold">#{{ row.id }}</span>
            <span> - </span>
            <span v-if="showIncomingNumber">
                <span class="font-weight-bold">{{ row.phone_number | fixPhone }}</span>
            </span>
            <span v-else-if="showVerifiedCallerId">
                <span class="font-weight-bold">{{ row.friendly_name }}</span>
            </span>
            <span v-else-if="showTollFreeVerification">
                <span class="font-weight-bold">Toll-Free Verification</span>
            </span>
            <span v-else-if="showRcsDetails">
                <span class="font-weight-bold">RCS</span>
            </span>
            <span
                class="font-weight-bold"
                v-else-if="displayName"
            >
                {{ displayName }}
            </span>
            <span v-else>-</span>
        </p>

        <!-- Email (if showEmail is true) -->
        <p v-if="showEmail" class="mb-0">
            <span v-if="!!row.email">
                {{ row.email }}
            </span>
            <span v-else>-</span>
        </p>

        <!-- Phone Number and SID for Verified Caller IDs -->
        <template v-if="showVerifiedCallerId">
            <p class="mb-0">{{ row.phone_number }}</p>
            <p class="mb-0">{{ mainSid }}</p>
        </template>
        <!-- SID for other types -->
        <p v-else class="mb-0">{{ mainSid }}</p>

        <!-- A2P Brand (if showA2pBrand is true) -->
        <template v-if="showA2pBrand">
            <p v-if="a2pBrand" class="mb-0 font-weight-bold">
                #{{ a2pBrandId }} - A2P Brand
            </p>
            <p v-if="a2pBrand" class="mb-0">{{ a2pBrandSid }}</p>
        </template>

        <!-- A2P Profile Bundle (if showA2pProfileBundle is true) -->
        <template v-if="showA2pProfileBundle">
            <p v-if="a2pProfileBundle" class="mb-0 font-weight-bold">
                #{{ a2pProfileBundleId }} - A2P Profile Bundle
            </p>
            <p v-else-if="hasA2pProfileBundleSid" class="mb-0 font-weight-bold">
                A2P Profile Bundle
            </p>
            <p v-if="a2pProfileBundleSid" class="mb-0">{{ a2pProfileBundleSid }}</p>
        </template>

        <!-- Incoming Number (if showIncomingNumberColumn is true) -->
        <template v-if="showIncomingNumberColumn">
            <p v-if="incomingNumber" class="mb-0 font-weight-bold">
                #{{ incomingNumberId }} - Incoming Number
            </p>
            <p v-if="incomingNumber" class="mb-0">{{ incomingNumberPhone | fixPhone }}</p>
            <p v-if="incomingNumber" class="mb-0">{{ incomingNumberSid }}</p>
        </template>

        <!-- Messaging Service (if showMessagingService is true) -->
        <template v-if="showMessagingService">
            <p v-if="messagingService" class="mb-0 font-weight-bold">
                #{{ messagingServiceId }} - Messaging Service
            </p>
            <p v-if="messagingService" class="mb-0">{{ messagingServiceSid }}</p>
            <p v-if="messagingServiceA2pUseCase" class="mb-0 font-weight-bold">
                #{{ messagingServiceA2pUseCaseId }} - A2P Campaign
            </p>
            <p v-if="messagingServiceA2pCampaignSid" class="mb-0">
                {{ messagingServiceA2pCampaignSid }}
            </p>
        </template>

        <!-- Toll-Free Verification (if showTollFreeVerificationColumn is true) -->
        <template v-if="showTollFreeVerificationColumn">
            <p v-if="tollFreeVerification" class="mb-0 font-weight-bold">
                #{{ tollFreeVerificationId }} - Toll-Free Verification
            </p>
            <p v-if="tollFreeVerification" class="mb-0">{{ tollFreeVerificationSid }}</p>
        </template>

        <!-- Customer Profile (if showCustomerProfile is true) -->
        <template v-if="showCustomerProfile">
            <p v-if="customerProfile" class="mb-0 font-weight-bold">
                #{{ customerProfileId }} - Customer Profile
            </p>
            <p v-else-if="hasCustomerProfileBundleSid" class="mb-0 font-weight-bold">
                Customer Profile
            </p>
            <p v-if="customerProfileSid" class="mb-0">{{ customerProfileSid }}</p>
        </template>

        <!-- STIR/SHAKEN Bundle (if showStirShakenBundles is true) -->
        <template v-if="showStirShakenBundles">
            <p v-if="stirShakenBundle" class="mb-0 font-weight-bold">
                #{{ stirShakenBundleId }} - STIR/SHAKEN
            </p>
            <p v-if="stirShakenBundle" class="mb-0">{{ stirShakenBundleSid }}</p>
        </template>

        <!-- Voice Integrity Bundle (if showVoiceIntegrityBundles is true) -->
        <template v-if="showVoiceIntegrityBundles">
            <p v-if="voiceIntegrityBundle" class="mb-0 font-weight-bold">
                #{{ voiceIntegrityBundleId }} - Voice Integrity
            </p>
            <p v-if="voiceIntegrityBundle" class="mb-0">{{ voiceIntegrityBundleSid }}</p>
        </template>

        <!-- Address (if showAddress is true) -->
        <template v-if="showAddress">
            <p v-if="address" class="mb-0 font-weight-bold">
                #{{ addressId }} - Address
            </p>
            <p v-else-if="hasAddressSid" class="mb-0 font-weight-bold">Address</p>
            <p v-if="addressSid" class="mb-0">{{ addressSid }}</p>
        </template>

        <!-- Emergency Address (if showEmergencyAddress is true) -->
        <template v-if="showEmergencyAddress">
            <p v-if="emergencyAddress" class="mb-0 font-weight-bold">
                #{{ emergencyAddressId }} - Emergency Address
            </p>
            <p v-else-if="hasEmergencyAddressSid" class="mb-0 font-weight-bold">Emergency Address</p>
            <p v-if="emergencyAddressSid" class="mb-0">{{ emergencyAddressSid }}</p>
        </template>

        <!-- Verified Caller ID Details (if showVerifiedCallerIdDetails is true) -->
        <template v-if="showVerifiedCallerIdDetails">
            <!-- Additional SIDs -->
            <p v-if="verifiedCallerIdCallSid" class="mb-0 font-weight-bold">Call SID</p>
            <p v-if="verifiedCallerIdCallSid" class="mb-0">{{ verifiedCallerIdCallSid }}</p>
        </template>

        <!-- Regulatory Bundle (if showRegulatoryBundle is true) -->
        <template v-if="showRegulatoryBundle">
            <p v-if="regulatoryBundle" class="mb-0 font-weight-bold">
                #{{ regulatoryBundleId }} - Regulatory Bundle
            </p>
            <p v-else-if="hasRegulatoryBundleSid" class="mb-0 font-weight-bold">Regulatory Bundle</p>
            <p v-if="regulatoryBundleSid" class="mb-0">{{ regulatoryBundleSid }}</p>
        </template>

        <!-- RCS Details (if showRcsDetails is true) -->
        <template v-if="showRcsDetails">
          <p v-if="rcs" class="mb-0 font-weight-bold">
            Sender ID
          </p>
          <p v-if="rcs" class="mb-0">{{ rcsSenderId }}</p>
        </template>
    </div>
</template>

<script>
export default {
    name: 'InformationColumn',
    props: {
        row: {
            type: Object,
            required: true
        },
        showEmail: {
            type: Boolean,
            default: false
        },
        nameField: {
            type: String,
            default: 'friendly_name'
        },
        showA2pCampaign: {
            type: Boolean,
            default: false
        },
        showA2pBrand: {
            type: Boolean,
            default: false
        },
        showA2pProfileBundle: {
            type: Boolean,
            default: false
        },
        showCustomerProfile: {
            type: Boolean,
            default: false
        },
        showTollFreeVerification: {
            type: Boolean,
            default: false
        },
        showTollFreeVerificationColumn: {
            type: Boolean,
            default: false
        },
        showIncomingNumber: {
            type: Boolean,
            default: false
        },
        showIncomingNumberColumn: {
            type: Boolean,
            default: false
        },
        showAddress: {
            type: Boolean,
            default: false
        },
        showEmergencyAddress: {
            type: Boolean,
            default: false
        },
        showRegulatoryBundle: {
            type: Boolean,
            default: false
        },
        showMessagingService: {
            type: Boolean,
            default: false
        },
        showStirShakenBundles: {
            type: Boolean,
            default: false
        },
        showVoiceIntegrityBundles: {
            type: Boolean,
            default: false
        },
        showVerifiedCallerId: {
            type: Boolean,
            default: false
        },
        showVerifiedCallerIdDetails: {
            type: Boolean,
            default: false
        },
        showRcsDetails: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        displayName() {
            // Handle different name field patterns (until fully refactor other trust bundles like stir/shaken, voice integrity, cnam, etc.)
            if (this.nameField.includes('.')) {
                // Handle nested properties like 'a2p_profile_bundle.friendly_name'
                const fields = this.nameField.split('.')
                let value = this.row
                for (const field of fields) {
                    value = value?.[field]
                    if (!value) break
                }
                return value
            }
            return this.row[this.nameField]
        },
        hasA2pCampaign() {
            return this.row?.a2p_use_case?.a2p_campaign_sid
        },
        a2pCampaignId() {
            return this.row?.a2p_use_case?.id
        },
        a2pCampaignSid() {
            return this.row?.a2p_use_case?.a2p_campaign_sid
        },
        a2pBrand() {
            return this.row.a2p_brand || this.row?.a2p_use_case?.a2p_brand
        },
        a2pBrandId() {
            return this.a2pBrand?.id
        },
        a2pBrandSid() {
            return this.a2pBrand?.sid
        },
        a2pProfileBundle() {
            return this.row.a2p_profile_bundle || this.row.a2p_use_case?.a2p_brand?.a2p_profile_bundle
        },
        a2pProfileBundleId() {
            return this.a2pProfileBundle?.id
        },
        a2pProfileBundleSid() {
            return this.a2pProfileBundle?.sid || this.row.a2p_profile_bundle_sid
        },
        hasA2pProfileBundleSid() {
            return this.row.a2p_profile_bundle_sid && !this.a2pProfileBundle
        },
        customerProfile() {
            return this.row.customer_profile || this.row.a2p_use_case?.customer_profile
        },
        customerProfileId() {
            return this.customerProfile?.id
        },
        customerProfileSid() {
            return this.customerProfile?.sid || this.row.customer_profile_bundle_sid
        },
        hasCustomerProfileBundleSid() {
            return this.row.customer_profile_bundle_sid && !this.customerProfile
        },
        stirShakenBundle() {
            return this.row.stir_shaken ?? null
        },
        stirShakenBundleId() {
            return this.stirShakenBundle?.id
        },
        stirShakenBundleSid() {
            return this.stirShakenBundle?.sid
        },
        voiceIntegrityBundle() {
            // For Branded Caller ID, get Voice Integrity from compliance_registration
            if (this.row.compliance_registration?.voice_integrity) {
                return this.row.compliance_registration.voice_integrity
            }
            // For other bundle types, use direct relationships
            return this.row.voice_integrity_bundle || this.row.voice_integrity
        },
        voiceIntegrityBundleId() {
            return this.voiceIntegrityBundle?.id
        },
        voiceIntegrityBundleSid() {
            return this.voiceIntegrityBundle?.sid
        },
        address() {
            return this.row.address
        },
        addressId() {
            return this.address?.id
        },
        addressSid() {
            return this.address?.sid || this.row.address_sid
        },
        hasAddressSid() {
            return this.row.address_sid && !this.address
        },
        emergencyAddress() {
            return this.row.emergency_address
        },
        emergencyAddressId() {
            return this.emergencyAddress?.id
        },
        emergencyAddressSid() {
            return this.emergencyAddress?.sid || this.row.emergency_address_sid
        },
        hasEmergencyAddressSid() {
            return this.row.emergency_address_sid && !this.emergencyAddress
        },
        regulatoryBundle() {
            return this.row.regulatory_bundle
        },
        regulatoryBundleId() {
            return this.regulatoryBundle?.id
        },
        regulatoryBundleSid() {
            return this.regulatoryBundle?.sid || this.row.regulatory_bundle_sid
        },
        hasRegulatoryBundleSid() {
            return this.row.regulatory_bundle_sid && !this.regulatoryBundle
        },
        mainSid() {
            return this.row.sid || this.row.bundle_sid || '-'
        },
        messagingService() {
            return this.row.messaging_service
        },
        messagingServiceId() {
            return this.messagingService?.id
        },
        messagingServiceSid() {
            return this.messagingService?.sid
        },
        messagingServiceA2pUseCase() {
            return this.messagingService?.a2p_use_case
        },
        messagingServiceA2pUseCaseId() {
            return this.messagingServiceA2pUseCase?.id
        },
        messagingServiceA2pCampaignSid() {
            return this.messagingServiceA2pUseCase?.a2p_campaign_sid
        },
        tollFreeVerification() {
            return this.row.toll_free_messaging_verification
        },
        tollFreeVerificationId() {
            return this.tollFreeVerification?.id
        },
        tollFreeVerificationSid() {
            return this.tollFreeVerification?.sid
        },
        incomingNumber() {
            return this.row.incoming_number
        },
        incomingNumberId() {
            return this.incomingNumber?.id
        },
        incomingNumberPhone() {
            return this.incomingNumber?.phone_number
        },
        incomingNumberSid() {
            return this.incomingNumber?.sid
        },
        verifiedCallerIdCallSid() {
            return this.row.call_sid
        },
        rcs() {
          return this.row.rcs ?? this.row
        },
        rcsSenderId() {
          return this.rcs?.sender_id
        },
    }
}
</script>
